import React from 'react';
export function OpeningHook() {
  return <section className="mb-16" data-id="element-315">
      <p className="text-xl text-[#1B2951] mb-4 font-['Inter']" data-id="element-316">Dear Friend,</p>
      <p className="text-lg text-[#2C3E50] mb-4 font-['Inter']" data-id="element-317">
        If you're reading this, you probably clicked on an ad about collagen
        that works in 15 days instead of 90.
      </p>
      <p className="text-lg text-[#2C3E50] mb-4 font-['Inter']" data-id="element-318">
        And you're probably VERY skeptical. I was too.
      </p>
      <p className="text-lg text-[#2C3E50] mb-4 font-['Inter']" data-id="element-319">
        But before you close this page, let me share why I, personally, spent 2
        years and over ₹3 crores upgrading our bestselling collagen formula –
        even everyone - my team, my board, and my wife thought I was crazy.
      </p>
    </section>;
}